import { StackedColumnComponent } from '../charts/stacked-column-chart-component'

export class AFCompareSovBySource extends StackedColumnComponent {
 static config = {
  selector: 'afCompareSovBySource',
  controller: AFCompareSovBySource,
  bindings: StackedColumnComponent.config.bindings,
  template: StackedColumnComponent.config.template,
 }

 setProperties() {
  this.toolTipLabel = 'Query: '
  this.seriesColors = this.colorUtils.compareMetaColors(this.visualizationMetaData)
 }

 updateData(data) {
  this.visualizationDataArray = this.isObjEmpty(data)
   ? []
   : this.sortCompareLoop(
      this.compareChartData(data, this.visualizationMetaData),
      'name',
      this.visualizationMetaData
     )
 }
}
